import React from 'react';

interface State {
    hasError: boolean;
}

class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
    constructor(props: React.PropsWithChildren) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        console.error('ErrorBoundary caught:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="alert alert-danger m-4" role="alert">
                    <strong>Noe gikk galt.</strong> Last siden på nytt eller kontakt support hvis problemet vedvarer.
                </div>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
